/* eslint-disable compat/compat */
export class ProductForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const { getGenderFromFilename, isPackshotImage } = window.BAO.Utils
    const url = new URL(window.location)
    if (url.searchParams.has('gender')) {
      const gender = url.searchParams.get('gender')
      const genderedImages = [
        ...document.querySelectorAll(
          '[data-product-media-carousel-el] img, [data-product-media-stacked-el] img',
        ),
      ].filter(
        img =>
          getGenderFromFilename(img.src) !== null || isPackshotImage(img.src),
      )

      const genderImage = genderedImages[0]?.src

      if (genderImage) {
        this.querySelector('form').insertAdjacentHTML(
          'afterbegin',
          `<input data-gender-line-property id="gender" type="hidden" name="properties[_gender_preference]" value="${gender}">
          <input data-gender-image-line-property id="gender_image" type="hidden" name="properties[_gender_image]" value="${genderImage}">
          `,
        )
      }
    }
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.announceItemHasBeenAddedToCart.bind(this),
    )
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  announceItemHasBeenAddedToCart () {
    this.externalEls.cartDrawer.element.focus()
    const announcementEl = this.els.announcement.element
    announcementEl.textContent = announcementEl.dataset.announcementText
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
